import React, { forwardRef, useCallback } from "react";
import { MainPageBody } from "./MainPageBody";
import { MainPageHeader } from "./MainPageHeader";
const MainPageInner = forwardRef(({ children, className, domRef, id }, ref) => {
    // Support both ref (forwardRef) and domRef (legacy callback ref)
    const setRef = useCallback((element) => {
        // Handle forwardRef
        if (typeof ref === "function") {
            ref(element);
        }
        else if (ref) {
            ref.current = element;
        }
        // Handle legacy domRef callback
        if (domRef && element) {
            domRef(element);
        }
    }, [ref, domRef]);
    return (React.createElement("div", { className: (className || "") + " main-page-inner", id: id, ref: setRef }, children));
});
MainPageInner.displayName = "MainPage";
export const MainPage = MainPageInner;
MainPage.Body = MainPageBody;
MainPage.Header = MainPageHeader;
export default MainPage;
